import types from '../actions/types'

const { FETCH_REASON_LIST } = types

function reasonsListBlockReducer(state = {}, action = {}) {
  switch (action.type) {
    case FETCH_REASON_LIST: {
      return {
        ...state,
        reasons: action.state
      }
    }
    default:
      return state
  }
}

export default reasonsListBlockReducer



// WEBPACK FOOTER //
// ./src/alelo-logic/reducers/reasonListBlockReducer.js